/**
 * Created by danielg on 9/21/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var _logger;
    var _queueModel;
    var _queueAdapter;
    var _channel;
    var _uiPath;
    var _modelMap;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var QueueOrbController = BaseController.extend(function QueueOrbController(options) {
        _uiPath = this.MODEL_UI_STATE_PATH;
        _modelMap = this.LPModelMap;
        _logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        _channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
        if (options) {
            _setModel(options.model);
            _setAdapter(options.adapter);
        }
        if (_queueModel) {
            _setValue(_modelMap.acceptTitle, 'LEWebAgent.waitingInQueue');
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.connectionStateChange, _setConnectionState.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.ringCountChange, _onRingCountUpdated.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.autoAccepting, _onAutoAccepting.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.acceptSuccess, _onAcceptSuccess.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.acceptError, _onAcceptError.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.maxChatsChange, _onMaxChatsChange.bind(this));
            lpTag.WebAgent.channel.bind(_channel.name, _channel.events.timerChange, _updateTimerConfig.bind(this));
            // respond to next isn't supported for messaging
            _toggleNTAButtonVisibility.call(this, options.respondToNextVisible || false);
        }
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    QueueOrbController.prototype.applicationType = 'QueueOrbController';
    QueueOrbController.prototype.MODEL_UI_STATE_PATH = 'UIState.QueueOrb';

    QueueOrbController.prototype.LPModelMap = {
        connected: 'connected',
        ringingCount: 'ringingCount',
        acceptTitle: 'acceptTitle',
        tooltip: 'tooltip',
        hasEngagements: 'hasEngagements',
        acceptingInProgress: 'acceptingInProgress',
        blink: 'blink',
        maxChatsReached: 'maxChatsReached',
        timerEnabled: 'timerEnabled',
        timerTimeLeft: 'timerTimeLeft',
        hotkey: 'hotkey',
        respondToNextButtonVisible: 'respondToNextButtonVisible',
        respondToNextButtonEnabled: 'respondToNextButtonEnabled'
    };

    QueueOrbController.prototype.LPPersistentDataMap = {
        queueOrbTimerTimeStamp: 'queueOrbTimerTimeStamp'
    };

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * Fires the TNA (respond to next) event
     */
    QueueOrbController.prototype.showFirstInQueue = function () {
        window.App.viewEventsHandler.fireEvent({
            appName: "ResponseQueueManager",
            UIEvent: window.App.viewEventsHandler.eventType.SHOW_FIRST_IN_QUEUE
        });
    };

    /**
     * Accepts a chat (if possible) and sets the accepting in progress indication
     */
    QueueOrbController.prototype.acceptChat = function () {
        if (_queueAdapter.canAcceptChat() && !_getValue(_modelMap.acceptingInProgress)) {
            _showAccepting.call(this, true);
            _queueAdapter.acceptChat();
        }
    };

    /**
     * Indicates if the controller can accept a chat
     * @returns {*|boolean}
     */
    QueueOrbController.prototype.canAcceptChat = function() {
        return _queueAdapter.canAcceptChat();
    };

    /////////////////////////////////// CALLBACK METHODS ///////////////////////////////////
    /**
     * Sets the connection state of the Queue Orb
     * @param isConnected
     * @private
     */
    function _setConnectionState(isConnected) {
        if (isConnected) {
            _connectQueueButton.call(this);
        } else {
            _disconnectQueueButton.call(this);
        }
    }

    /**
     * Updates the ring count and initializes the timer
     * @param count
     * @private
     */
    function _onRingCountUpdated(data) {
        _startOrStopTimer.call(this);
        _updateRingingCount.call(this, {newValue: data && data.count});
    }

    /**
     * Shows the accepting in progress indication
     * @private
     */
    function _onAutoAccepting() {
        _showAccepting.call(this, true);
    }

    /**
     * Hides the accepting in progress indication and lowers the ringing count
     * @param data
     * @private
     */
    function _onAcceptSuccess(data) {
        _showAccepting.call(this, false);
    }

    /**
     * Hides the accepting in progress indication
     * @param errorData
     * @private
     */
    function _onAcceptError(errorData) {
        _showAccepting.call(this, false);
    }

    /**
     * Shows or hides the max chats reached indication based on the adapter state
     * @param data
     * @private
     */
    function _onMaxChatsChange(data) {
        _showOrHideMaxChats();
    }

    /**
     * Updates the Timer config. Sets the timer if there are chats in the queue
     * @param data Contains isTimerEnabled and awayTimeOut
     * @private
     */
    function _updateTimerConfig(data) {
        this.showTimer = (data && data.isTimerEnabled) || false;
        this.awayTimeOut = data && data.awayTimeOut ? parseInt(data.awayTimeOut, 10) : null;
        _startOrStopTimer.call(this);
    }

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////
    /**
     * Sets if the NTA (Next to Take Action - Respond to Next) button is visible, and binds to events if it is.
     * @param isVisible
     * @private
     */
    function _toggleNTAButtonVisibility(isVisible) {
        _setValue(_modelMap.respondToNextButtonVisible, isVisible);
        if (isVisible) {
            window.App.viewEventsHandler.bindEvent({
                appName: "ResponseQueueManager",
                UIEvent: window.App.viewEventsHandler.eventType.NEXT_TO_TAKE_ACTION_REGISTER,
                context: this,
                callback: _enableNTA
            });
            window.App.viewEventsHandler.bindEvent({
                appName: "ResponseQueueManager",
                UIEvent: window.App.viewEventsHandler.eventType.NEXT_TO_TAKE_ACTION_UNREGISTER,
                context: this,
                callback: _disableNTA
            });
        }
    }

    /**
     * Register to NEXT_TO_TAKE_ACTION, set the button to enable and set the hot key
     * @param event
     */
    function _enableNTA(event) {
        // We only update the state if we were called by an external event. If we're updating the UI only, no need
        // to update our internal state.
        if (event) {
            this.isNTAActive = true;
        }
        if (_queueAdapter.isConnected) {
            _setValue(_modelMap.respondToNextButtonEnabled, true);
        }
    }

    /**
     * Unregister to NEXT_TO_TAKE_ACTION, set the button to disable and disable the hot key
     * @param event
     */
    function _disableNTA(event) {
        // We only update the state if we were called by an external event. If we're updating the UI only, no need
        // to update our internal state.
        if (event) {
            this.isNTAActive = false;
        }
        _setValue(_modelMap.respondToNextButtonEnabled, false);
    }

    /**
     * Connects the queue button. Enables all the actions and removes the connection problems tooltip.
     * @private
     */
    function _connectQueueButton() {
        _setValue(_modelMap.connected, true);
        _setQueueOrbTooltip('');
        // if NTA was active before the service disconnected, restore it
        if (this.isNTAActive) {
            _enableNTA.call(this);
        }
    }

    /**
     * Disconnects the queue button. Disables any action and shows the connection problems tooltip.
     * @private
     */
    function _disconnectQueueButton() {
        _setValue(_modelMap.connected, false);
        _setQueueOrbTooltip('LEWebAgent.connectionProblemQueueOrbTooltip');
        // if NTA is active, disable it
        if (this.isNTAActive) {
            _disableNTA.call(this);
        }
    }

    /**
     * Updates the ringing count and checks if the queue orb is able to accept.
     * @param event - The ringing update event
     * @private
     */
    function _updateRingingCount(event) {
        var newRingingCount = event.newValue || 0;
        if (_getValue(_modelMap.ringingCount) !== newRingingCount) {
            _setValue(_modelMap.ringingCount, newRingingCount);
            if (_queueAdapter.hasChatsInQueue()) {
                _showAccept.call(this);
            } else {
                _hideAccept.call(this);
            }
        }
    }

    /**
     * Shows that the queue orb is able to accept incoming requests
     * @private
     */
    function _showAccept() {
        if (!this.acceptVisible) {
            if (!_queueAdapter.maxChatsReached) {
                _handleHotkeys("register", {position : "top"});
            }
            this.acceptVisible = true;
            _setValue(_modelMap.acceptTitle, 'LEWebAgent.accept');
            _setValue(_modelMap.hasEngagements, true);
        }
        _refreshBlink();
    }

    /**
     * Hides the indication that the queue orb can accept incoming requests
     * @private
     */
    function _hideAccept() {
        if (this.acceptVisible) {
            _handleHotkeys("unregister");
            if (this.showTimer) {
                _stopTimer.call(this);
            }
            _setValue(_modelMap.blink, false);
            this.acceptVisible = false;
            _setValue(_modelMap.acceptTitle, 'LEWebAgent.waitingInQueue');
            _setValue(_modelMap.hasEngagements, false);
        }
    }

    /**
     * Sets the hotkey state (to register or unregister)
     * @param operationName - The operation (register or unregister)
     * @param tooltipProperty - Data for the tooltip
     * @private
     */
    function _handleHotkeys(operationName, tooltipProperty) {
        operationName += "Shortcut";
        var value = {key: 'ACCEPT_NEXT_CHAT', action: operationName};
        if (tooltipProperty) {
            value.data = tooltipProperty;
        }
        _setValue(_modelMap.hotkey, value, true);
    }

    /**
     * Shows or hides the max chats reached indication, based on the current state.
     * @private
     */
    function _showOrHideMaxChats() {
        if (_queueAdapter.maxChatsReached) {
            _showMaxChats();
        } else {
            _hideMaxChats();
        }
    }

    /**
     * Shows the max chats reached indication
     * @private
     */
    function _showMaxChats() {
        if (!_getValue(_modelMap.maxChatsReached)) {
            _setValue(_modelMap.blink, false);
            _setValue(_modelMap.maxChatsReached, true);
            if (_queueAdapter.hasChatsInQueue()) {
                _handleHotkeys("unregister");
            }
        }
    }

    /**
     * Hides the max chats reached indication
     * @private
     */
    function _hideMaxChats() {
        if (_getValue(_modelMap.maxChatsReached)) {
            _setValue(_modelMap.maxChatsReached, false);
            if (_queueAdapter.hasChatsInQueue()) {
                _handleHotkeys("register", {position : "top"});
                _refreshBlink();
            }
        }
    }

    /**
     * Starts or stops the timer
     * @private
     */
    function _startOrStopTimer() {
        if (this.showTimer && _queueAdapter.canAcceptChat()) {
            _updateAndRegisterTimer.call(this);
        } else {
            _stopTimer.call(this);
        }
    }

    /**
     * Updates and registers the timer based on session storage and current state.
     * @private
     */
    function _updateAndRegisterTimer() {
        var timerStartTime = this.getSessionData({
            name: this.applicationType,
            key: this.LPPersistentDataMap.queueOrbTimerTimeStamp
        });  //trying to retrieve if the timer is running - and when it started from session storage.
        var newAwayTimeOut;
        var nowInMs = new Date().getTime();
        if (timerStartTime) {
            var timerStartTimeInMs = parseInt(timerStartTime, 10);
            var diffInSec = Math.round((nowInMs - timerStartTimeInMs) / 1000);
            newAwayTimeOut = this.awayTimeOut - diffInSec;
        }
        else {
            timerStartTime = nowInMs;
            newAwayTimeOut = this.awayTimeOut;
        }
        if (newAwayTimeOut <= 0) {
            _setQueueOrbTimer.call(this, {callsLeft: 0});
        }
        else {
            _setQueueOrbTimer.call(this, {callsLeft: newAwayTimeOut});
            if (window.App.timerManager.registerTimer) {
                window.App.timerManager.registerTimer({
                    context: this,
                    callback: _setQueueOrbTimer,
                    numOfCalls: newAwayTimeOut,
                    interval: 1
                }); //run according to newAwayTimeOut, every 1 sec
            }
            this.saveSessionData({
                name: this.applicationType,
                key: this.LPPersistentDataMap.queueOrbTimerTimeStamp,
                value: timerStartTime
            });
        }
    }

    /**
     * Stops the Timer of the Queue Orb.
     * @private
     */
    function _stopTimer() {
        _setValue(_modelMap.timerEnabled, false);
        _removeValue(_modelMap.timerTimeLeft);
        if (window.App.timerManager.unregisterTimer) {
            window.App.timerManager.unregisterTimer({context: this, callback: _setQueueOrbTimer});
        }
        this.removeSessionData({
            name: this.applicationType,
            key: this.LPPersistentDataMap.queueOrbTimerTimeStamp
        });
    }

    /**
     * Sets the current timer for the Queue Orb
     * @param data - contains the number of calls left from the timer manager (equal to the number of seconds left)
     * @private
     */
    function _setQueueOrbTimer(data) {
        if (this.showTimer && _queueAdapter.canAcceptChat()) {
            _setValue(_modelMap.timerEnabled, true);
            _setValue(_modelMap.timerTimeLeft, data.callsLeft);
        }
    }

    /**
     * Refreshes the blink of the button. This is done when we were already blinking, but something changed so we want
     * the blink to start over.
     * @private
     */
    function _refreshBlink() {
        _setValue(_modelMap.blink, false);
        setTimeout(function() {
            if (!_queueAdapter.maxChatsReached) {
                _setValue(_modelMap.blink, true);
            }
        }, 0);
    }

    /**
     * Sets if the Queue orb has an accepting in progress. Also sets internal state accordingly.
     * @param enabled - If true the orb is accepting in progress. If false it is not.
     * @private
     */
    function _showAccepting(enabled) {
        _setValue(_modelMap.acceptingInProgress, enabled);
    }

    /**
     * Sets the tooltip for the Queue Orb
     * @param text - The text to set
     * @private
     */
    function _setQueueOrbTooltip(text) {
        if (text) {
            _setValue(_modelMap.tooltip, text);
        }
        else {
            _setValue(_modelMap.tooltip, '');
        }
    }

    /**
     * Gets a UI state value from the model
     * @param location - The location within the UI sate data
     * @returns {*}
     * @private
     */
    function _getValue(location) {
        return _queueModel.get(_getModelLocationForValue(location));
    }

    /**
     * Removes a UI state value from the model
     * @param location - The location within the UI sate data
     * @private
     */
    function _removeValue(location) {
        _queueModel.removeKey(_getModelLocationForValue(location));
    }

    /**
     * Sets a UI state value in the model
     * @param location - The location within the UI sate data
     * @param value - The value to set
     * @param hardSet - If true use set, otherwise modify
     * @private
     */
    function _setValue(location, value, hardSet) {
        if (hardSet) {
            _queueModel.set(_getModelLocationForValue(location), value);
        } else {
            _queueModel.modify(_getModelLocationForValue(location), value);
        }
    }

    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            _queueModel = model;
        }
    }

    /**
     * Sets the adapter
     * @param adapter - the adapter
     * @private
     */
    function _setAdapter(adapter) {
        if (adapter) {
            _queueAdapter = adapter;
        }
    }

    /**
     * Gets the UI State path in the model
     * @param location - The location within the UI State area
     * @returns {*} The full model path
     * @private
     */
    function _getModelLocationForValue(location) {
        var path = _uiPath;
        if (location) {
            path += '.' + location;
        }
        return path;
    }

    return QueueOrbController;

});
